import { SearchOutlined } from "@ant-design/icons";
import { Col, Divider, Row, Space, Typography } from "antd";
import { useGetLastUserSearchs } from "../../ServertSideStates";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { useNavigate } from "react-router-dom";
import {
  handleSetAdvertListFilter,
} from "apps/RealState/ListItems/ClientStates";
import CustomNoData from "apps/Common/CustomNoData";
import { FC } from "react";
import { useQueryClient } from "react-query";
import endPoints from "apps/layout/Header/EndPoints";

const LastUserSearchs: FC<{ setSearchTerm: any }> = ({ setSearchTerm }) => {
  const { Text } = Typography;
  const lastUserSearchs = useGetLastUserSearchs();
  const { filter } = useSelector((state: RootState) => state.realState);
  const dispatch = useDispatch();
  const navigate = useNavigate();


  return (
    <>
      <Row className=" !px-4 !py-2  ">
        <Col xs={24}>
          <Space>
            <SearchOutlined />
            <Text className="!font-bold !text-[#a0a3a9]">Son Aramalar</Text>
          </Space>
        </Col>
        {lastUserSearchs?.data?.data?.length > 0 ? (
          <>
            {lastUserSearchs?.data?.data
              .filter((item: any) => item.searchKey || item?.categoryBreadCrumb)
              .map((item: any) => {
                return (
                  <>
                    <Col
                      xs={24}
                      className=" !px-4 !py-2 hover:!bg-[#f5f6f7] hover:cursor-pointer "
                      style={{ borderBottom: "1px solid #f5f6f7 " }}
                      onClick={async () => {
                        const currentFilter: any = {
                          PageIndex: 1,
                          PageSize: 20,

                          IncludeProperties: [
                            "User",
                            "Store",
                            "Currency",
                            "Country",
                            "City",
                            "District",
                            "Neighbourhood",
                            "AdvertMedia",
                            "AdvertMedia.Media",
                            "AdvertContactType",
                            "AdvertContactType.ContactType",
                            
                          ],
                          SortProperty: "price",
                          SortType: "asc",
                        };
                        currentFilter["IsSearchFilter"] = true;
                        if (item?.searchKey) {
                          currentFilter["Title"] = item?.searchKey;
                        }
                      

                        await dispatch(
                          handleSetAdvertListFilter({ filter: currentFilter })
                        );

                        navigate(
                          `/ilan${
                            item.searchKey
                              ? ""
                              : `${
                                  item.type === 0 ? "/gayrimenkul" : "/arac"
                                }/${item?.categoryUrl}`
                          }`
                        );
                        setSearchTerm("");
                      }}
                    >
                      <Text className="!text-xs">
                        {item?.searchKey || item?.categoryBreadCrumb || ""}
                      </Text>
                    </Col>
                    <Col xs={24}>
                      <Divider className="!m-0" />
                    </Col>
                  </>
                );
              }) || []}
          </>
        ) : (
          <>
            <CustomNoData description="Arama Geçmişiniz Bulunamadı" />
          </>
        )}
      </Row>
    </>
  );
};

export default LastUserSearchs;
